import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-removed-page',
    templateUrl: './removed-page.component.html',
    styleUrls: ['./removed-page.component.css']
})
export class RemovedPageComponent { 
    constructor(
        private readonly router: Router,
    ) { }

    public goHome(): void {
        this.router.navigate(['']);
    }
}